<template>
  <div
    v-if="!viewModel.HasGradReelPackage"
    class="photos"
  >
    <h2 class="section-header">
      <contentful-text :item="contentfulText('checkout-download-photos-head')" />
    </h2>
    <div
      v-if="!viewModel.AllPartsHaveFull"
      class="photos__fulls-uploading-warning"
    >
      <contentful-text :item="contentfulText('checkout-download-photos-fulls-uploading-warning')" />
    </div>
    <div class="photos__lede">
      <contentful-text :item="contentfulText('checkout-download-photos-lede')" />
      <span v-if="somePartsCurrentlyRetouching">
        <contentful-text :item="contentfulText('checkout-download-photos-retouching-warning')" />
      </span>
    </div>
    <div
      v-if="!somePartsCurrentlyRetouching && !isDesktop"
      class="photos__desktop-download-instructions"
    >
      <contentful-text :item="contentfulText('checkout-download-desktop-download-instructions')" />
    </div>
    <div v-if="!somePartsCurrentlyRetouching && isDesktop">
      <div class="row">
        <div class="col-xs-12 col-sm-3">
          <div class="photos__interstitial">
            <div class="photos__interstitial-line" />
            <div class="photos__interstitial-text">or</div>
          </div>
        </div>
      </div>
      <div class="photos__zip-file-downloads">
        <zip-file-download />
      </div>
    </div>
    <hr >
    <h3 class="photos__sub-head">
      <contentful-text :item="contentfulText('checkout-download-photos-sub-head')" />
    </h3>
    <video-clips v-if="hasVideoClips" />
    <div class="photos__photo-size-modal-link-wrapper">
      <a
        href="#"
        class="photos__photo-size-modal-link"
        @click.prevent="showPhotoSizeModal = true"
      >
        <contentful-text :item="contentfulText('checkout-download-photos-photo-size-modal-link')" />
        <span class="fa fa-chevron-right" />
      </a>
    </div>
    <photo-size-modal
      :show="showPhotoSizeModal"
      @modal-close="showPhotoSizeModal = false"
    />
    <div class="row">
      <div
        v-for="(productPart, index) in viewModel.Product.Parts"
        :key="index"
        class="col-xs-6 col-sm-3 col-md-2"
      >
        <div class="photos__photo">
          <div class="photos__photo-img-wrap">
            <img
              :class="productPart.Orientation"
              :src="productPart.SmallWatermarkedUrl"
              :alt="productPart.FriendlyDisplayName"
              :title="productPart.FriendlyDisplayName"
            >
          </div>
          <div class="photos__photo-frame-id">
            {{ productPart.FrameId }}
          </div>
          <div
            v-if="productPart.IsCurrentlyRetouching"
            class="photos__photo-retouching-message"
          >
            <contentful-text :item="contentfulText('checkout-download-photos-retouching-in-progress')" />
          </div>
          <download-links
            v-if="!productPart.IsCurrentlyRetouching"
            :product-part="productPart"
            :image-urls="getProductPartImageUrls(productPart.PartId)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DownloadLinks from './Photos/DownloadLinks'
import PhotoSizeModal from './Photos/PhotoSizeModal'
import ResponsiveBreakpointsMixin from '@Shared/mixins/responsive-breakpoints'
import VideoClips from './VideoClips'
import ZipFileDownload from './Photos/ZipFileDownload'
import { find } from 'lodash'

export default {
  name: 'Photos',
  components: {
    DownloadLinks,
    PhotoSizeModal,
    VideoClips,
    ZipFileDownload
  },
  mixins: [
    ResponsiveBreakpointsMixin
  ],
  data () {
    return {
      showPhotoSizeModal: false
    }
  },
  computed: {
    viewModel () {
      return this.$store.state.viewModel
    },
    somePartsCurrentlyRetouching () {
      return this.$store.getters.somePartsCurrentlyRetouching
    },
    content () {
      return this.viewModel.PageContent
    },
    hasVideoClips () {
      return this.$store.getters.hasVideoClips
    }
  },
  methods: {
    getProductPartImageUrls (productPartId) {
      return find(this.viewModel.ProductImageUrls, (iu) => {
        return iu.PartId === productPartId
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.photos {
  &__fulls-uploading-warning,
  &__lede,
  &__desktop-download-instructions {
    margin: 0 0 20px 0;
    text-align: center;
  }

  &__interstitial {
    position: relative;
    height: 20px;

    &-line {
      background-color: #999;
      height: 1px;
      position: absolute;
      top: 11px;
      width: 100%;
    }

    &-text {
      background-color: #fff;
      font-weight: bold;
      height: 100%;
      left: 45%;
      padding: 0 10px;
      position: absolute;
      top: 0;
    }
  }

  &__zip-file-downloads {
    margin-bottom: 40px;
  }

  &__sub-head {
    font-family: $font-open-sans;
    font-size: 22px;
    font-weight: bold;
    margin: 0 0 40px 0 !important;
    padding: 0;
    text-align: center;
  }

  &__photo {
    margin-bottom: 40px;

    &-img-wrap {
      background-color: #eee;
      min-height: 250px;
    }

    &-frame-id {
      text-align: center;
      font-weight: bold;
      margin: 4px 0;
    }

    &-retouching-message {
      text-align: center;
      color: #999;
    }
  }

  &__photo-size-modal-link {
    &-wrapper {
      margin: 0 0 10px 0;
    }

    font-size: 20px;
    font-weight: bold;
  }

  @media screen and (min-width: $screen-sm-min) {
    &__fulls-uploading-warning,
    &__lede,
    &__desktop-download-instructions {
      text-align: left;
    }

    &__sub-head {
      text-align: left;
    }
  }

  @media screen and (min-width: $screen-md-min) {
    &__photo {
      &-img-wrap {
        min-height: 260px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/checkout-download/components/Photos.vue